export const WORLD_LIFE_CONFIG = {
  fogOpacity: 0,
  fogSpeed: 8,
  fogScale: 1.35,
  fogDepth: 0.18,
  ambientParticleCount: 26,
  ambientParticleOpacity: 0.18,
  ambientParticleSpeed: 12,
  ambientParticleDepth: 0.34,
  ambientParticleTint: 0xb7ff64,
  organicSwayAmount: 0.018,
  organicSwaySpeed: 0.92,
  organicSwayRandomness: 1.4,
  glowPulseAmount: 0.08,
  glowPulseSpeed: 1.15,
  glowMaxAlpha: 0.92,
  glowMinAlpha: 0.74,
  footDustEnabled: true,
  footDustRate: 0.055,
  footDustOpacity: 0.2,
  footDustLifetime: 0.46,
  footDustOffsetY: 58,
  ghostFloatAmount: 7,
  ghostFloatSpeed: 1.12,
  ghostAuraAlpha: 0.16,
  ghostEyePulse: 0.22,
  cameraBreathingEnabled: true,
  cameraBreathingAmount: 1.4,
  cameraBreathingSpeed: 0.42
} as const;
